import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators} from '@angular/forms';
import { numberValidator } from 'src/app/_validators';

@Component({
  selector: 'app-datos-acudiente',
  standalone: false,
  templateUrl: './datos-acudiente.component.html',
  styleUrls: ['./datos-acudiente.component.scss', '../actualizacion_datos.scss']
})
export class DatosAcudienteComponent implements OnInit {

  @Input()
  datosAcudienteForm: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
  }

  getErrorMessage(controlPath: string) {
    const control = this.datosAcudienteForm.get(controlPath);
    return control.hasError('required') ? 'Este campo es requerido' :
        control.hasError('email') ? 'No es un email valido' :
        control.hasError('invalidNumber') ? 'No es un número valido' :
        control.hasError('invalidPhone') ? 'No es un número de telephono valido' :
            '';
  }
}
